import { select, put, call } from 'redux-saga/effects';
import { cognitoCleanAuthDataAction, tokenSelector } from '@/domain/env';
import { cleanStorageDataOnSignout } from '@/domain/env/sagas';

// this cleans data left from a previous session from storage and redux so that
// in index saga further rot sagas consider user not authorized
// this allows not to run workers that will trigger 401 logout from workers
// in case of expired token and IDp login
export function* cleanAuthData() {
  const hasPreviousSession = yield select(tokenSelector);
  if (hasPreviousSession) {
    yield call(cleanStorageDataOnSignout);
    yield put({ type: cognitoCleanAuthDataAction.type });
  }
}
